export class NoAuthError extends Error {
  public readonly type = "no_auth_user";
  public readonly caller: string;
  constructor(caller: string) {
    super(`no_auth_user: ${caller}`);
    this.caller = caller;
  }
}
